import React from 'react'
import { Modal } from 'antd'
import 'antd/dist/antd.css'
import './assets/_ConfirmHandler.scss'
import PropTypes from 'prop-types'

// eslint-disable-next-line react/prop-types
export default function ConfirmHandler ({ setModalvisible, setHandleOk, msg, title }) {
  return (
    <>

      <Modal title={title} okText="確定" okType="text" visible={setModalvisible} onOk={setHandleOk} >
        <p>{msg}</p>
      </Modal>

    </>
  )
}

ConfirmHandler.propTypes = {
  setModalvisible: PropTypes.bool.isRequired,
  setHandleOk: PropTypes.func.isRequired,
  setHandleCancel: PropTypes.func.isRequired
}
